var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidityTomorrowio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    className: "weather-filter-parameter__icon--Huru",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,4.9316c2.7796,3.1386,5.5,7.1143,5.5,9.696C17.5,17.5899,15.0327,20,12,20s-5.5-2.41-5.5-5.3724 C6.5,12.0459,9.2204,8.0702,12,4.9316 M12,2.4428c-0.2666,0-0.5332,0.1065-0.7316,0.3196C9.382,4.7884,4.5,10.4361,4.5,14.6276 C4.5,18.6993,7.8579,22,12,22c4.1422,0,7.5-3.3007,7.5-7.3724c0-4.1915-4.882-9.8392-6.7683-11.8651 C12.5332,2.5493,12.2666,2.4428,12,2.4428L12,2.4428z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,12.0511c0-0.8756,0.5718-1.4652,1.4295-1.4652c0.8532,0,1.4027,0.5763,1.4027,1.4652v0.1608 c0,0.8711-0.5852,1.4786-1.4295,1.4786c-0.8443,0-1.4027-0.5897-1.4027-1.4786V12.0511z M11.7208,13.3421l1.9879-2.5999 c0.2457-0.3216,0.5361-0.3038,0.7415-0.1519c0.1117,0.0804,0.1832,0.1876,0.1921,0.3127c0.0089,0.1251-0.0402,0.2725-0.1698,0.4333 l-1.9789,2.4927l-2.2693,2.9438c-0.2591,0.335-0.5539,0.2948-0.746,0.1474c-0.0893-0.067-0.1653-0.1653-0.1832-0.2904 c-0.0134-0.1251,0.0268-0.2725,0.1653-0.4467L11.7208,13.3421z M9.5453,12.1672c0,0.3976,0.1385,0.6343,0.3708,0.6343 c0.2278,0,0.3618-0.2368,0.3618-0.6343v-0.067c0-0.3976-0.1295-0.6254-0.3618-0.6254c-0.2368,0-0.3708,0.2234-0.3708,0.6254 V12.1672z M12.6678,15.2406c0-0.8756,0.5718-1.4652,1.4295-1.4652c0.8532,0,1.4027,0.5763,1.4027,1.4652v0.1608 c0,0.8711-0.5852,1.4786-1.4295,1.4786c-0.8443,0-1.4027-0.5897-1.4027-1.4786V15.2406z M13.7131,15.3568 c0,0.3976,0.1385,0.6343,0.3708,0.6343c0.2278,0,0.3618-0.2368,0.3618-0.6343v-0.067c0-0.3976-0.1295-0.6254-0.3618-0.6254 c-0.2368,0-0.3708,0.2234-0.3708,0.6254V15.3568z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityTomorrowio);
export default __webpack_public_path__ + "static/media/humidity-tomorrowio.65e0f0f5b3f4c8687d674a95c9c720cb.svg";
export { ForwardRef as ReactComponent };